import groq from 'groq'
import { mediaAsset } from '../../../projections/mediaAsset'

export const struggles = groq`
  _type,
  sideTagline,
  mainTitle,
  struggles[]{
    title,
    description,
    media[]{...${mediaAsset()}}
  },
  whatsMissing{
    title,
    description,
  },
`
